// Ottimizzazione del caricamento JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Funzione per ritardare l'esecuzione di script non critici
  function executeWhenIdle(callback) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(callback, { timeout: 2000 });
    } else {
      setTimeout(callback, 1000);
    }
  }
  
  // Funzione per eseguire script quando l'utente interagisce con la pagina
  function executeOnInteraction(callback) {
    var executed = false;
    
    function execute() {
      if (!executed) {
        executed = true;
        callback();
        
        // Rimuovi gli event listener dopo l'esecuzione
        ['mousemove', 'scroll', 'touchstart', 'keydown'].forEach(function(event) {
          document.removeEventListener(event, execute);
        });
      }
    }
    
    // Aggiungi event listener per vari tipi di interazione
    ['mousemove', 'scroll', 'touchstart', 'keydown'].forEach(function(event) {
      document.addEventListener(event, execute, { passive: true, once: true });
    });
    
    // Esegui comunque dopo 5 secondi se non c'è stata interazione
    setTimeout(execute, 5000);
  }
  
  // Inizializza le funzionalità non critiche in modo differito
  executeWhenIdle(function() {
    // Inizializza funzionalità non critiche qui
    // Questo verrà eseguito quando il browser è inattivo
    
    // Esempio: inizializza tooltip, popup, ecc.
    if (window.theme && window.theme.initLazyFeatures) {
      window.theme.initLazyFeatures();
    }
  });
  
  // Inizializza funzionalità basate sull'interazione
  executeOnInteraction(function() {
    // Inizializza funzionalità che richiedono interazione
    // Questo verrà eseguito solo quando l'utente interagisce con la pagina
    
    // Esempio: inizializza animazioni, effetti hover avanzati, ecc.
    if (window.theme && window.theme.initInteractionFeatures) {
      window.theme.initInteractionFeatures();
    }
  });
});
